import React from 'react';
import { Link } from 'react-router-dom';
import './RelationshipRecomm.css';

function RelationshipRecomm({ recommendation, onApply, onDismiss, showLinks = false }) {
  const {
    id,
    person1_id,
    person2_id,
    person1_first_name,
    person1_last_name,
    person2_first_name,
    person2_last_name,
    suggested_type,
    reason,
  } = recommendation;

  const person1Name = `${person1_first_name} ${person1_last_name}`.trim();
  const person2Name = `${person2_first_name} ${person2_last_name}`.trim();

  return (
    <div className="relationship-recomm">
      <div className="recomm-content">
        <div className="recomm-main">
          {showLinks ? (
            <span className="recomm-names">
              <Link to={`/member/${person1_id}`}>{person1Name}</Link>
              {' ↔ '}
              <Link to={`/member/${person2_id}`}>{person2Name}</Link>
            </span>
          ) : (
            <span className="recomm-names">
              {person1Name} ↔ {person2Name}
            </span>
          )}
          <span className="recomm-type">({suggested_type})</span>
        </div>
        <div className="recomm-reason">{reason}</div>
      </div>
      <div className="recomm-actions">
        <button
          onClick={() => onApply(id)}
          className="btn-recomm btn-apply"
          title="Apply this recommendation"
        >
          ✓
        </button>
        <button
          onClick={() => onDismiss(id)}
          className="btn-recomm btn-dismiss"
          title="Dismiss this recommendation"
        >
          ✗
        </button>
      </div>
    </div>
  );
}

export default RelationshipRecomm;
